import { Button } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import Flex from "../../../../../../components/Flex";
import CustomTitle from "../../../../../../components/app/CustomTitle";
import VisitNoteTableTemplate from "./VisitNoteTableTemplate";
import VisitNoteTemplateForm, {
  VisitNoteFormValues,
} from "./VisitNoteTemplateForm";
import ElevatedPaper from "../../../../../../components/ElevatedPaper";
import LabeledSwitch from "../../../../../../components/LabeledSwitch";
import { SHOW_ARCHIVED_TEMPLATES_LABEL } from "./visit-note-template-constant";

const VisitNoteTemplateLayout = () => {
  const [view, setView] = useState<"table" | "form" | "edit" | "view">("table");
  const queryClient = useQueryClient();
  const [selectedVisitNote, setSelectedVisitNote] =
    useState<VisitNoteFormValues>();
  const [showArchived, setShowArchived] = useState<boolean>(false);

  return (
    <ElevatedPaper>
      <Flex flexDirection="column" gap={2}>
        <Flex flexDirection={"column"} gap={2}>
          <Flex
            justifyContent="space-between"
            alignItems={"center"}
            gap={2}
            paddingRight={1}
          >
            <CustomTitle>Visit Note Templates</CustomTitle>

            {view === "table" ? (
              <Flex gap={2.5} alignItems={"center"}>
                <LabeledSwitch
                  label={SHOW_ARCHIVED_TEMPLATES_LABEL}
                  checked={showArchived}
                  onChange={(e) => setShowArchived(e.target.checked)}
                />
                <Button variant="contained" onClick={() => setView("form")}>
                  Add New Template
                </Button>
              </Flex>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setView("table");
                  setSelectedVisitNote(undefined);
                }}
              >
                Close
              </Button>
            )}
          </Flex>
          <Flex flexDirection={"column"} gap={2}>
            {view === "table" ? (
              <VisitNoteTableTemplate
                // remount on toggle so paging and sorting restart for the new list
                key={String(showArchived)}
                showArchived={showArchived}
                setCurView={(v) => {
                  setView(v);
                }}
                setSelectedVisitNote={setSelectedVisitNote}
              />
            ) : (
              <VisitNoteTemplateForm
                prefillData={selectedVisitNote}
                readOnly={view === "view"}
                onSave={() => {
                  queryClient.invalidateQueries({
                    queryKey: ["visit-note-template-get-all"],
                  });
                  setView("table");
                  setSelectedVisitNote(undefined);
                }}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
    </ElevatedPaper>
  );
};

export default VisitNoteTemplateLayout;
